import { render, staticRenderFns } from "./MetaLogo.vue?vue&type=template&id=d5c84688"
import script from "./MetaLogo.vue?vue&type=script&lang=ts"
export * from "./MetaLogo.vue?vue&type=script&lang=ts"
import style0 from "./MetaLogo.vue?vue&type=style&index=0&id=d5c84688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports